import { get, post, put } from '@/util/request'
import urlConfig from '@/config/urlConfig'

export default {
  applyData(params) {
    return post(
      urlConfig.baseUrl + '/api/email/apply',
      params
    )
  },
  postContact(params) {
    return post(
      urlConfig.baseUrl + '/api/email/contact',
      params
    )
  },
  // 获取验证码
  getMobileCode(params) {
    return post(
      urlConfig.baseUrl + '/user/getMobileCode',
      params
    )
  },
  // 用户注册
  userReg(params) {
    return post(
      urlConfig.baseUrl + '/user/userReg',
      params
    )
  },
  // 用户实名制
  userIdentity(params) {
    return post(
      urlConfig.baseUrl + '/user/userIdentity',
      params
    )
  },
  // 账号密码登陆
  login(params) {
    return post(
      urlConfig.baseUrl + '/user/login',
      params
    )
  },
  // 手机验证码登陆
  loginByPhone(params) {
    return post(
      urlConfig.baseUrl + '/user/loginByPhone',
      params
    )
  },
  // 用户退出
  loginOut(params) {
    return get(
      urlConfig.baseUrl + '/user/loginOut',
      params
    )
  },
  // 微信授权登录redirectUri
  wxAuthBack(params) {
    return get(
      urlConfig.baseUrl + '/wx/wxAuthBack',
      params
    )
  },
  // 微信扫码登录
  getWxPath(params) {
    return get(
      urlConfig.baseUrl + '/getWxPath',
      params
    )
  },
  // 用户找回密码
  findPwd(params) {
    return post(
      urlConfig.baseUrl + '/user/findPwd',
      params
    )
  },
  // 获取用户信息
  getuserinfo(params) {
    return post(
      urlConfig.baseUrl + '/user/getUserInfo',
      params
    )
  },
  // 获取调查问卷
  getQuestionList(params) {
    return post(
      urlConfig.baseUrl + '/user/getQuestionList',
      params
    )
  },
  // 保存用户问卷信息
  saveUserChoice(params) {
    return get(
      urlConfig.baseUrl + '/user/saveUserChoice',
      params
    )
  },
  // 专家登录
  expertlogin(params) {
    return post(
      urlConfig.baseUrl + '/expert/login',
      params
    )
  },
  // 专家登出
  expertloginOut(params) {
    return post(
      urlConfig.baseUrl + '/expert/loginOut',
      params
    )
  },
  // 专家获取打分任务列表
  taskList(params) {
    return get(
      urlConfig.baseUrl + '/expert/taskList',
      params
    )
  },
  // 获取打分维度
  gradeContent(params) {
    return post(
      urlConfig.baseUrl + '/expert/gradeContent',
      params
    )
  },
  // 专家打分
  scoring(params) {
    return put(
      urlConfig.baseUrl + '/expert/scoring',
      params
    )
  },
  // 用户申请新角色
  applyNewRole(params) {
    return post(
      urlConfig.baseUrl + '/user/applyNewRole',
      params
    )
  },
  // 获取作品列表
  getMusicList(params) {
    return post(
      urlConfig.baseUrl + '/music/getMusicList',
      params
    )
  },
}



// WEBPACK FOOTER //
// ./src/api/index.js